(ns dre.widgets.analysis.tag-distribution
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.network :as-alias network]
   [dre.utils.query :as query]
   [dre.utils :refer [stringify-keys-with-namespaces aborted-request?]] 
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path [:widgets :analysis-tag-distribution])

;; -- Events

(rf/reg-event-fx
 ::set-loading
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {:db (assoc db :state :loading)}))

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn
  [{db :db} [{:keys [after-fx last-selected-filter-key pills-api-params-fn]}]]
  (let [params
        (-> (pills-api-params-fn [:demographics :geography :publication-type])
            (assoc :response/filter {:distribution true}))]
    {:db (assoc db :state :loading)
     ::network/request-with-abort [{:endpoint :widgets/tag-distribution}
                                   {:body (stringify-keys-with-namespaces params)
                                    :on-success [::success {:after-fx after-fx :last-selected-filter-key last-selected-filter-key}]
                                    :on-failure [::failure {:after-fx after-fx}]}]})))

(rf/reg-event-fx
 ::success
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [after-fx last-selected-filter-key ::fetch-fx/response]}]]
  (let [res (:distribution (:body response))
        data (cond-> (:data db)
               (not= last-selected-filter-key :demographics) (assoc :demographics res)
               (not= last-selected-filter-key :geography) (assoc :geography res)
               (not= last-selected-filter-key :publication-type) (assoc :publication-type res))]
    {:db {:state :success
          :data data}
     :dispatch after-fx})))

(rf/reg-event-fx
 ::failure
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [{:keys [after-fx ::fetch-fx/response] :as opts}]] 
  (if (aborted-request? response)
    {}
    {:db {:state :failure
        :data nil}
   :dispatch-n [after-fx
                [:dre.network/default-failure (merge {:event :tag-distrubution} opts)]]})))

;; -- Subscriptions
(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))